import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch social list data
export const getPaymentAuthorizationList = createAsyncThunk(
  "paymentAuthorizationList/getPaymentAuthorizationList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/cleaning/payment_autorization`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const paymentAuthorizationSlice = createSlice({
  name: "paymentAuthorizationList",
  initialState: {
    loading: false,
    paymentAuthorizationData: null,
    error: null,
  },
  reducers: {
    ResetPaymentAuthorizationDataState: (state) => {
      state.loading = false;
      state.paymentAuthorizationData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentAuthorizationList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPaymentAuthorizationList.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentAuthorizationData = action.payload;
      })
      .addCase(getPaymentAuthorizationList.rejected, (state, action) => {
        state.loading = false;
        state.paymentAuthorizationData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetPaymentAuthorizationDataState } =
  paymentAuthorizationSlice.actions;
export default paymentAuthorizationSlice.reducer;
